"use client";

import { useState } from "react";
import { LuMonitorDown, LuX } from "react-icons/lu";
import { Button } from "@/components/ui/button";
import { IosInstallDialog } from "@/components/common/IosInstallDialog";
import { useInstallAvailability } from "@/utils/hooks/useInstallAvailability";

// Banner "Instalar como app" del admin (PWA de `public/manifest.webmanifest`,
// start_url /scheduling). Va al pie del área autenticada, en el flujo del layout
// (no fixed), así que no tapa contenido. Solo aparece cuando la instalación es realmente
// posible (ver useInstallAvailability); en Chrome/Edge dispara el diálogo nativo,
// en iPad/iPhone abre las instrucciones compartidas con la app móvil.

const DISMISS_KEY = "admin_install_dismissed_at";

export function AdminInstallBanner() {
  const { platform, canInstall, dismissed, dismiss, triggerNativeInstall } =
    useInstallAvailability({ dismissKey: DISMISS_KEY });
  const [iosDialogOpen, setIosDialogOpen] = useState(false);

  if (!canInstall || dismissed) return null;

  function handleInstall() {
    if (platform === "ios") {
      setIosDialogOpen(true);
      return;
    }
    void triggerNativeInstall();
  }

  return (
    <div className="w-full shrink-0 border-t border-border bg-ac-4 py-2 px-4 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-4 text-fg">
          <LuMonitorDown className="h-5 w-5 shrink-0" aria-hidden />
          <p className="text-sm">
            <span className="font-bold">Instala Orquesti como app. </span>
            {/* <span className="text-fg-muted">
              Ábrela directo desde tu escritorio o pantalla de inicio, en su propia ventana.
            </span> */}
          </p>
        </div>
        <div className="flex flex-shrink-0 items-center gap-3">
          <Button variant="strong" size="sm" onClick={handleInstall}>
            Instalar
          </Button>
          <Button
            variant="ghost"
            size="sm"
            className="h-8 w-8 rounded-full p-0 text-fg-muted hover:text-fg"
            onClick={dismiss}
            title="Cerrar"
            aria-label="Cerrar"
          >
            <LuX className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {platform === "ios" && (
        <IosInstallDialog
          open={iosDialogOpen}
          onOpenChange={setIosDialogOpen}
        />
      )}
    </div>
  );
}
